module.exports = __webpack_public_path__ + "img/wepublic-des.85756ff9.png";